import { Model } from "../model";

export interface VariablePoint extends Model {
    environmentId: string;
    variableId: string;
    culturesIds: string[];
}